import { RedoFulfillmentToteSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-tote";
import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const createTotes = {
  name: "createTotes" as const,
  input: z.object({
    totes: z.array(
      z.object({
        name: z.string(),
        barcode: z.string().max(255).nullish(),
        locationId: locationIdFormat.schema,
      }),
    ),
  }),
  output: z.object({ totes: z.array(RedoFulfillmentToteSchema) }),
};

export type CreateTotesInput = z.infer<typeof createTotes.input>;
